module.exports = __webpack_public_path__ + "img/img-meal-plan-empty-illustration.d81540e6.svg";